import { formatDistanceToNow, parseISO } from "date-fns";
import { ptBR } from "date-fns/locale";
import type { Notification } from "@/adapters/api";

export function notificationMessage(notification: Notification): string {
	const actor = notification.actor?.name ?? "Alguém";
	switch (notification.type) {
		case "comment_mention":
			return `${actor} mencionou você em "${notification.title}"`;
		case "post_comment":
			return `${actor} comentou em "${notification.title}"`;
		default:
			return notification.title;
	}
}

export function formatNotificationTime(iso: string): string {
	return formatDistanceToNow(parseISO(iso), { addSuffix: true, locale: ptBR });
}
